export default "/images/programm-bg.png?a17d562dc9ae934a640de8a856c3c474";